export const environment = {
    production: false,
    url: "https://staging-empower.gentari.co.in/",
    onboardingUrl: "https://staging-onboarding.gentari.co.in/",
    appraisalUrl: "https://staging-appraisal.gentari.co.in",
    serverUrl: "http://4.224.80.4/",
    clientId: '9e029027-bd6d-403c-9fae-afe6959cde82',
    secretKey: '86v8Q~Zh4az-MPkes9Kiefru9gzqJzzHHojwVcRq',
    authority: 'https://login.microsoftonline.com/8b24551d-7c2c-4beb-8b61-95f32d9929ef/',
    redirectUri: 'https://staging-empower.gentari.co.in/home',
    tenantId: '8b24551d-7c2c-4beb-8b61-95f32d9929ef',
    firebase: {
    apiKey: 'AIzaSyCOYX6WLMohmYAexIpu1Wvuu6TDcrEpb3A',
    authDomain: 'empower-form.firebaseapp.com',
    projectId: 'empower-form',
    storageBucket: 'empower-form.firebasestorage.app',
    messagingSenderId: '385156398003',
    appId: '1:385156398003:web:2e4b232b799fa9b1e369c6',
    measurementId: 'G-FKV8J1VEE6'
  }
}